import { render, staticRenderFns } from "./Busqueda.vue?vue&type=template&id=cea6ea1e&"
import script from "./Busqueda.vue?vue&type=script&lang=js&"
export * from "./Busqueda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports